export const API_URL = "https://stocktaking.xeniacatalogue.info/api/";
// export const API_URL = "https://venuxenia.bsite.net/api/";
